import type { GolfTournament } from '@img-arena/consoles-api-dde'
import { ddeApi } from '@/service/ddeApi'

import { createBaseTableStore } from '../table'
import { FetchApiResponse } from '../table/table.types'

export const fetchApi = async (): Promise<FetchApiResponse<GolfTournament>> => {
  const { data } = await ddeApi.endpoints.golf.tournaments.getTournaments()

  return {
    content: data,
    totalElements: data.length
  }
}

export const useGolfPricingStore = createBaseTableStore({
  storeName: 'DDE Golf Pricing',
  fetchApi
})
